import React from "react";
import './Dashboard.css';

const Dashboard = () => {
  return (
    <div className="dashboard-page">
      <h2>Dashboard Content</h2>
      <p>This is where your dashboard widgets or charts will go.</p>
    </div>
  );
};

export default Dashboard;
